import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiEnvelope } from '../../models/auth.dto';
import {
  AddParticipantRequest,
  CreateProjectRequest,
  ParticipantResponse,
  ProjectResponse,
  UpdateProjectRequest,
} from '../../models/project.dto';

@Injectable({ providedIn: 'root' })
export class ProjectService {
  private apiUrl = environment.cbdx_service.api_path;

  constructor(private http: HttpClient) {}

  list(page = 0, size = 20): Observable<ApiEnvelope<ProjectResponse[]>> {
    const params = new HttpParams().set('page', page).set('size', size);
    return this.http.get<ApiEnvelope<ProjectResponse[]>>(`${this.apiUrl}/projects`, { params });
  }

  get(id: string): Observable<ApiEnvelope<ProjectResponse>> {
    return this.http.get<ApiEnvelope<ProjectResponse>>(`${this.apiUrl}/projects/${id}`);
  }

  create(request: CreateProjectRequest): Observable<ApiEnvelope<ProjectResponse>> {
    return this.http.post<ApiEnvelope<ProjectResponse>>(`${this.apiUrl}/projects`, request);
  }

  update(id: string, request: UpdateProjectRequest): Observable<ApiEnvelope<ProjectResponse>> {
    return this.http.patch<ApiEnvelope<ProjectResponse>>(`${this.apiUrl}/projects/${id}`, request);
  }

  listParticipants(projectId: string): Observable<ApiEnvelope<ParticipantResponse[]>> {
    return this.http.get<ApiEnvelope<ParticipantResponse[]>>(`${this.apiUrl}/projects/${projectId}/participants`);
  }

  addParticipant(projectId: string, request: AddParticipantRequest): Observable<ApiEnvelope<ParticipantResponse[]>> {
    return this.http.post<ApiEnvelope<ParticipantResponse[]>>(
      `${this.apiUrl}/projects/${projectId}/participants`,
      request
    );
  }

  removeParticipant(projectId: string, companyId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/projects/${projectId}/participants/${companyId}`);
  }
}
